import { render, staticRenderFns } from "./PmSideBar.vue?vue&type=template&id=4f0b42a2&scoped=true&"
import script from "./PmSideBar.vue?vue&type=script&lang=js&"
export * from "./PmSideBar.vue?vue&type=script&lang=js&"
import style0 from "./PmSideBar.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PmSideBar.vue?vue&type=style&index=1&id=4f0b42a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0b42a2",
  null
  
)

export default component.exports